export const Development = true;
const Constant = {
  REGEX: {
    EMAIL: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  },
  BASE_URL: Development
    ? 'https://api.nopapertimesheet.com'
    : 'https://api.nopapertimesheet.com',
};

export default Constant;
